import { Drawer, Popover } from 'antd'
import { useAuthentication } from 'context/AuthContext'

import logoIntegraSocial from '../../assets/logos/integra-social.svg'
import logoutIcon from '../../assets/icons/logout-icon.svg'
import bigDataSocialLogo from '../../assets/logos/big-data-social.svg'

import './styles.scss'
import Hamburger from 'components/Icons/Hamburguer'
import { useEffect, useState } from 'react'
import { Device } from 'components/Device'
import { contentButton } from 'utils/contentButtons'
import { useFamily } from 'context/hooks/useFamily'
import useQuery from 'context/hooks/useQuery'
import { NavLink } from 'react-router-dom'
import { useAccessibility } from 'context/hooks/useAccessibility'
import { hasImage } from 'utils/utils'

function AsideMenuMobile() {
  const [menuIsOpen, setMenuIsOpen] = useState(false)

  const { authData, handleLogout } = useAuthentication()

  const currentWidth = Device.useDevice().currentWidth()

  const { infosKinship, numberAlertsPerSections } = useFamily()

  const { basesQuery } = useQuery()

  const { contrastIsSelected } = useAccessibility()

  const bigDataSocialHref =
    process.env.REACT_APP_BIGDATA_URL != null && authData.token != null
      ? `${process.env.REACT_APP_BIGDATA_URL}?token=${authData.token}}`
      : ''

  const integraSocialHref =
    process.env.REACT_APP_API_CZRM != null && authData.token != null
      ? `${process.env.REACT_APP_API_CZRM}?token=${authData.token}`
      : ''

  useEffect(() => {
    setMenuIsOpen(false)
  }, [currentWidth > 650])

  const hasImageLocal: boolean = hasImage(authData)

  const logoutButton = () => {
    return (
      <button
        className="logout"
        onClick={() => {
          handleLogout()
        }}
      >
        <img src={logoutIcon} alt="Ícone de logout" />
        <span>SAIR</span>
      </button>
    )
  }

  const showDrawer = () => {
    setMenuIsOpen(true)
  }

  const onClose = () => {
    setMenuIsOpen(false)
  }

  return (
    <section className="containerAsideMenuMobile">
      <div className="containerAsideMenuMobile-menu">
        <button
          onClick={() => {
            showDrawer()
          }}
          className="containerAsideMenuMobile-menu__buttonIcon"
        >
          <Hamburger
            color={
              contrastIsSelected
                ? 'var(--contrast-graphical-background-color)'
                : 'white'
            }
            type="2"
          />
          <span>MENU</span>
        </button>
        <img src={logoIntegraSocial} alt="Logo do integra social" />
        <Popover content={logoutButton} trigger="click" placement="left">
          <button className="containerAsideMenuMobile-menu__user">
            {hasImageLocal ? (
              <img src={authData.user.image} alt="Foto do usuário logado" />
            ) : (
              <p> {authData.user.name[0]}</p>
            )}
          </button>
        </Popover>
      </div>
      <Drawer
        placement="left"
        title={
          <div className="containerAsideMenuMobile-content__logo">
            <a href={integraSocialHref}>
              <img
                src={logoIntegraSocial}
                alt="Logo do integra social"
                width={'100%'}
              />
            </a>
          </div>
        }
        onClose={onClose}
        visible={menuIsOpen}
        closeIcon={
          <Hamburger
            isOpen={true}
            color={
              contrastIsSelected
                ? 'var(--contrast-graphical-background-color)'
                : 'white'
            }
            type="2"
          />
        }
        className={`containerAsideMenuMobile-content ${
          contrastIsSelected ? 'contrastMode' : ''
        }`}
        bodyStyle={{
          padding: 0,
          background: contrastIsSelected
            ? 'var(--contrast-background-color)'
            : 'var(--green-dark)',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
        headerStyle={{
          background: contrastIsSelected
            ? 'var(--contrast-background-color)'
            : 'var(--green-dark)',
          border: 'none',
        }}
      >
        <ul className="containerAsideMenuMobile-content__options">
          {contentButton(numberAlertsPerSections).map((component, index) => {
            const withAlert =
              Boolean(component?.alert) && (component.alert ?? 0) > 0
            return (
              <li
                key={component.title}
                className="containerAsideMenuMobile-content__options--option"
              >
                <NavLink
                  to={`${process.env.PUBLIC_URL}/pesquisa/${
                    component.param
                  }?cpf=${infosKinship?.cpf ?? ''}&nis=${
                    infosKinship?.nis ?? ''
                  }&bases=${JSON.stringify(basesQuery)}`}
                  onClick={() => {
                    onClose()
                  }}
                >
                  <div>
                    <div className="containerAsideMenuMobile-content__options--option__icon">
                      {component.icon}
                    </div>
                    <span className="containerAsideMenuMobile-content__options--option__title">
                      {component.title}
                    </span>
                  </div>
                  {withAlert && (
                    <div className="alertRight">{component.alert}</div>
                  )}
                </NavLink>
              </li>
            )
          })}
        </ul>

        <div className="containerAsideMenuMobile-content__infos">
          <a
            className="containerAsideMenuMobile-content__infos--logo"
            href={bigDataSocialHref}
          >
            <img src={bigDataSocialLogo} alt="Logo do Big Data Social" />
            <span>BIG DATA SOCIAL</span>
          </a>
          <div className="containerAsideMenuMobile-content__infos--user">
            <Popover content={logoutButton} trigger="click">
              <button>
                {hasImageLocal ? (
                  <img src={authData.user.image} alt="Foto do usuário logado" />
                ) : (
                  <p> {authData.user.name[0]}</p>
                )}
              </button>
            </Popover>
            <span>{authData.user.name}</span>
          </div>
        </div>
      </Drawer>
    </section>
  )
}

export default AsideMenuMobile
